import { ColumnDef, createColumnHelper } from '@tanstack/react-table'

import { OrdersCardsDataTypes } from 'types/orders-details-westfieldcorp'

export const useTablesOrdersCards = ({
  dataTable,
}: {
  dataTable: OrdersCardsDataTypes[]
}) => {
  const columnHelper = createColumnHelper<OrdersCardsDataTypes>()
  const columns = [
    columnHelper.accessor('traderId', {
      header: () => 'Trader #',
      cell: (info) => {
        const traderId = info.getValue()

        return (
          <p className="flex flex-col">
            <span>{traderId}</span>
          </p>
        )
      },
    }),
    columnHelper.accessor('cardNumber', {
      header: () => 'Card #',
      cell: (info) => {
        const card = info.getValue()

        return (
          <p className="flex flex-col">
            <span>{card}</span>
          </p>
        )
      },
    }),
  ] as ColumnDef<OrdersCardsDataTypes>[]

  return {
    dataTable,
    columns,
  }
}
